import Header from "./Header";
import PropTypes from "prop-types";
import { Logo } from "./Logo";
import { Tabs } from "./Tabs";

const Layout = ({ children }) => {
 return (
  <div className="flex bg-image">
   <div className="w-[300px] bg-white min-h-screen float-left">
    <div className="w-[300px]">
     <Header>
      <Logo />
     </Header>
     <div className="side-nav z-10">
      <Tabs />
     </div>
    </div>
   </div>
   <div className="w-remain">
    <div className="content relative flex-1 px-10 pt-20">{children}</div>
   </div>
  </div>
 );
};

Layout.propTypes = {
 children: PropTypes.node.isRequired,
};

export default Layout;
